module.exports = "/assets/data/d99bbce6b0c4a01a92316e6af5df7d3c-SK4.data.json";